// The string values must match the backend PersonalTrainingActivityType enum from common
export enum TourType {
  BOOK_A_TOUR = 'CLUB_TOUR',
  CLUB_WELCOME = 'WELCOME_MEETING',
  TRIAL = 'CLUB_TOUR_TRIAL',
}
